import { Injectable } from '@angular/core';

export interface MenuItem {
  path: string;
  label: string;
  icon: string;
  iconActive?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserSpaceMenuService {
  getAdminMenu(): MenuItem[] {
    return [
      { path: '/admin/dashboard', label: 'Dashboard', icon: './assets/images/icons/dashboard/dashboard.png', iconActive: './assets/images/icons/dashboard/dashboard_red.png'},
      { path: '/admin/agents', label: 'Agents', icon: './assets/images/icons/dashboard/user_card.png', iconActive: './assets/images/icons/dashboard/user_card_red.png'},
      { path: '/admin/clients', label: 'Clients', icon: './assets/images/icons/dashboard/users.png', iconActive: './assets/images/icons/dashboard/users_red.png'},
      { path: '/admin/reservations', label: 'Réservations', icon: './assets/images/icons/dashboard/shield_check.png', iconActive: './assets/images/icons/dashboard/shield_check_red.png'},
      { path: '/admin/articles', label: 'Articles', icon: './assets/images/icons/dashboard/file.png', iconActive: './assets/images/icons/dashboard/file_red.png'},
      { path: '/admin/mail-box', label: 'Mail box', icon: './assets/images/icons/dashboard/mail.png', iconActive: './assets/images/icons/dashboard/mail_red.png'},
      { path: '/admin/profile', label: 'Profil', icon: './assets/images/icons/dashboard/profile.png', iconActive: './assets/images/icons/dashboard/profile_red.png'}
    ];
  }

  getMemberMenu(): MenuItem[] {
    return [
      { path: '/member/profile', label: 'Profil', icon: './assets/images/icons/dashboard/profile.png' },
      { path: '/admin/reservations', label: 'Réservations', icon: './assets/images/icons/dashboard/shield_check.png', iconActive: './assets/images/icons/dashboard/shield_check_red.png'},
      { path: '/member/mail-box', label: 'Mail box', icon: './assets/images/icons/dashboard/mail.png', iconActive: './assets/images/icons/dashboard/mail_red.png'}
    ];
  }
}